module.exports = __webpack_public_path__ + "img/weight-eggs.ea73ef68.png";